/** Neutral 24x24 structures every people can raise — no racial styling. */
export const ART_BUILDINGS_COMMON: string[][][] = [
  /* 0 Keep — twin corner towers, crenellated curtain, crest over the gate */
  [
    [
      '            #           ',
      '            #PPP        ',
      '            #ppp        ',
      '            #           ',
      '  N N N     #    N N N  ',
      '  NNNNN     #    NNNNN  ',
      '  NnnnN     #    NnnnN  ',
      '  NnnnNNN  NN  NNNnnnN  ',
      '  NnnnNNNNNNNNNNNNnnnN  ',
      '  NnnnNnNnnnnnnNnNnnnN  ',
      '  Nn#nNnn#nnnn#nnNn#nN  ',
      '  Nn#nNnn#nnnn#nnNn#nN  ',
      '  NnnnNnnnPPPPnnnNnnnN  ',
      '  NnnnNnnpPPPPpnnNnnnN  ',
      '  NnnnNnnnppppnnnNnnnN  ',
      '  NNNNNNNNNNNNNNNNNNNN  ',
      '  Nn#nNnnnnnnnnnnNn#nN  ',
      '  Nn#nNnnn####nnnNn#nN  ',
      '  NnnnNnnn#bb#nnnNnnnN  ',
      '  NnnnNnnn#by#nnnNnnnN  ',
      '  NnnnNnnn#bb#nnnNnnnN  ',
      '  nnnnnnnn#bb#nnnnnnnn  ',
      ' nnnnnnnnn#bb#nnnnnnnnn ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 1 Farm — barn, windmill and crop rows; frame 1 turns the sails */
  [
    [
      '                        ',
      '                 w      ',
      '                Nw      ',
      '                Nw      ',
      '                NwNNN   ',
      '             wwwwwwwww  ',
      '      PP      NNNwN     ',
      '     PPPP        wN     ',
      '    PPPPPP       wN     ',
      '   PPPPPPPP    PPPPP    ',
      '  PPPPPPPPPP   qqqqq    ',
      '  pppppppppp   qqyqq    ',
      '  wwwwyywwww   qqqqq    ',
      '  wwwbbbbwww  qqqqqqq   ',
      '  wwwbybbwww  qqqqqqq   ',
      '  wwwbbbbwww qqqqqqqqq  ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' yybyybyybyybyybyybyyby ',
      ' ggbggbggbggbggbggbggbg ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' yybyybyybyybyybyybyyby ',
      ' ggbggbggbggbggbggbggbg ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' oooooooooooooooooooooo ',
    ],
    [
      '                        ',
      '             N       N  ',
      '              N     N   ',
      '               w   w    ',
      '                w w     ',
      '                 w      ',
      '      PP        w w     ',
      '     PPPP      w   w    ',
      '    PPPPPP    N     N   ',
      '   PPPPPPPP  N PPPPP N  ',
      '  PPPPPPPPPP   qqqqq    ',
      '  pppppppppp   qqyqq    ',
      '  wwwwyywwww   qqqqq    ',
      '  wwwbbbbwww  qqqqqqq   ',
      '  wwwbybbwww  qqqqqqq   ',
      '  wwwbbbbwww qqqqqqqqq  ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' yybyybyybyybyybyybyyby ',
      ' ggbggbggbggbggbggbggbg ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' yybyybyybyybyybyybyyby ',
      ' ggbggbggbggbggbggbggbg ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 2 Lumber Camp — standing pine, axed stump, saw shed, stacked timber */
  [
    [
      '                        ',
      '    GGG                 ',
      '   GgggG                ',
      '  GgggggG               ',
      ' GgggggggG              ',
      ' GgggggggG              ',
      '  GgggggG       PP      ',
      '   GgggG      PPPPPP    ',
      '    ggg     PPPPPPPPPP  ',
      '    wbw    pPPPPPPPPPPp ',
      '    wbw    wqqqqqqqqqqw ',
      '    wbw    wqqqqqqqqqqw ',
      '    wbw    wqqmmmmmmqqw ',
      '    wbw    wqqddddddqqw ',
      '    wbw    wqqqqqqqqqqw ',
      '    wbw    wqqqqqqqqqqw ',
      '    wbw    bbbbbbbbbbbb ',
      '    wbw w  bbbbbbbbbbbb ',
      '    wbwmm  qwwwwwwwwwwq ',
      '   wwbww   qbbbbbbbbbbq ',
      '  wwwbwww  qwwwwwwwwwwq ',
      '  bbbbbbb  qbbbbbbbbbbq ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 3 Quarry — terraced rock face, timber derrick, dressed blocks on the floor */
  [
    [
      '                        ',
      '                  wPPP  ',
      '                  wppp  ',
      '     nnnnn    wwwww     ',
      '   nNNNNNNNn  d   w     ',
      '  nNNNNNNNNNn d   w     ',
      ' nNNnNNNNNNnNnd   w     ',
      ' nnnnnnnnnnnnnd   w     ',
      ' nNNNNNNNNNNNnd   w     ',
      ' nnnnnnnnnnnnnm   w     ',
      ' nNNnnNNnnNNnNNNN w     ',
      ' nnnnnnnnnnnnNnnN w     ',
      ' nNNNNNNNNNNnNNNN w     ',
      ' nnnnnnnnnnnn    www    ',
      ' nnnnnnnnnnn    wwwww   ',
      ' nnnnnnnnn      bbbbb   ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      '  NNNN NNNN NNNN NNNN   ',
      '  nnnn nnnn nnnn nnnn   ',
      '  NNNN PPPP NNNN NNNN   ',
      '  nnnn pppp nnnn nnnn   ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      ' nNnnNnnnNnnNnnnNnnNnnn ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 4 Ley Shrine — a floating arcane crystal over a runed dais and menhirs */
  [
    [
      '      c          c      ',
      '    v              v    ',
      '           vv           ',
      '          vccv          ',
      '         vccccv         ',
      '        vccvvccv        ',
      '    c   vcvvvvcv   c    ',
      '        vcvvvvcv        ',
      '        vccvvccv        ',
      '         vccccv         ',
      '          vccv          ',
      '           vv           ',
      '           cc           ',
      '          c  c          ',
      '   nNn            nNn   ',
      '   ncn            ncn   ',
      '   nNn            nNn   ',
      '   nnn            nnn   ',
      '   nnnNNNNNNNNNNNNnnn   ',
      '   nnNNNNcPPPPcNNNNnn   ',
      '   nnNNNNcppppcNNNNnn   ',
      '  nnnnnnnnnnnnnnnnnnnn  ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 5 Village — three cottages round a dirt yard, smoke off the back chimney.
     Smoke is 'o' (shadow) here, matching the Thieves' Den, the Forge Hall and
     the Golem Foundry. It used to be 'N' (light stone), which is the wall key —
     three pale pixels over a roof read as flying rubble, not as smoke. */
  [
    [
      '         o              ',
      '        oo              ',
      '        o               ',
      '        dd  P           ',
      '        dd PPP          ',
      '        ddPPPPP         ',
      '        PPPPPPPPP       ',
      '       ppppppppppp      ',
      '        nqqqqqqqn       ',
      '        nqqyqyqqn       ',
      '     P  nqqqqqqqn       ',
      '    PPP nqqqqqqqn P     ',
      '   PPPPPnnnnnnnnnPPP    ',
      '  PPPPPPP       PPPPP   ',
      ' ppppppppp     ppppppp  ',
      ' wqqqqqqqw     wqqqqqw  ',
      ' wqyqqqyqw     wqyqyqw  ',
      ' wqqqqqqqw     wqqqqqw  ',
      ' wqqbbbqqw     wqbbbqw  ',
      ' wqqbybqqw     wqbybqw  ',
      ' bbbbbbbbb     bbbbbbb  ',
      ' qqqqqqqqqqqqqqqqqqqqqq ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 6 Watchtower — slender crenellated stone shaft, arrow slits, arched door */
  [
    [
      '            #PPPP       ',
      '            #PPPP       ',
      '            #ppp        ',
      '            #           ',
      '      NN NN NN NN       ',
      '      NNNNNNNNNNN       ',
      '      NnNnNnNnNnN       ',
      '       nNNNNNNNn        ',
      '       nNNN#NNNn        ',
      '       nNNN#NNNn        ',
      '       nNNNNNNNn        ',
      '       nnnnnnnnn        ',
      '       nNNNNNNNn        ',
      '       nNN#N#NNn        ',
      '       nNN#N#NNn        ',
      '       nNNNNNNNn        ',
      '       nNpPPPpNn        ',
      '       nNNpPPpNn        ',
      '       nnnnnnnnn        ',
      '      nNNNNNNNNNn       ',
      '     nNNNN###NNNNn      ',
      '    nnnnnnbbbnnnnnn     ',
      '   nnnnnnnbbbnnnnnnn    ',
      '  ooooooooooooooooooo   ',
    ],
  ],
  /* 7 Market — striped awning on posts, laden counter, crates, barrels, sacks */
  [
    [
      '   #PPP          PPP#   ',
      '   #pp            pp#   ',
      '   #                #   ',
      '        PPNNPPNN        ',
      '      NNPPNNPPNNPP      ',
      '    PPNNPPNNPPNNPPNN    ',
      '   NPPNNPPNNPPNNPPNNP   ',
      '   nppnnppnnppnnppnnp   ',
      '   w    q      q    w   ',
      '   w   yyy    rrr   w   ',
      '   w                w   ',
      '   w yyy  ggg  rrr  w   ',
      '   wwwwwwwwwwwwwwwwww   ',
      '   bbbbbbbbbbbbbbbbbb   ',
      '   w                w   ',
      '   wwwwwww          w   ',
      '   wwbbbbw qqqq     w   ',
      '   wwbbbbw qddq qqq w   ',
      '   wwbbbbw qddq qyq w   ',
      '   wwwwwww qqqq qqq w   ',
      '   wbbbbbb bbbb bbb w   ',
      ' qqqqqqqqqqqqqqqqqqqqqq ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' oooooooooooooooooooooo ',
    ],
  ],
  /* 8 Harbour — moored cog under sail beside a piled jetty; frame 1 moves the swell */
  [
    [
      '        #PP             ',
      '        #               ',
      '        #               ',
      '        #PPPP           ',
      '        #PPPPP          ',
      '        #PPPPPP         ',
      '        #PPPPPPP        ',
      '        #pppppppp       ',
      '        #pppppppp       ',
      '        wwwwwwwwww wwww ',
      '        #          wbbw ',
      '        #          wwww ',
      '        #      qqq bbbb ',
      '        #      qdq      ',
      '        #     wwwwwwwww ',
      ' wwwwwwwwwwwwwbbbbbbbbb ',
      ' bwwwwwwwwwwwb w  w  w  ',
      '  bwwwwwwwwwb  w  w  w  ',
      '   bbbbbbbbb   w  w  w  ',
      ' ccccccccccccccwccwccwc ',
      ' ccaccaccaccaccaccaccac ',
      ' accaccaccaccaccaccacca ',
      ' AccAccAccAccAccAccAccA ',
      ' AAAAAAAAAAAAAAAAAAAAAA ',
    ],
    [
      '        #PP             ',
      '        #               ',
      '        #               ',
      '        #PPPP           ',
      '        #PPPPP          ',
      '        #PPPPPP         ',
      '        #PPPPPPP        ',
      '        #pppppppp       ',
      '        #pppppppp       ',
      '        wwwwwwwwww wwww ',
      '        #          wbbw ',
      '        #          wwww ',
      '        #      qqq bbbb ',
      '        #      qdq      ',
      '        #     wwwwwwwww ',
      ' wwwwwwwwwwwwwbbbbbbbbb ',
      ' bwwwwwwwwwwwb w  w  w  ',
      '  bwwwwwwwwwb  w  w  w  ',
      '   bbbbbbbbb   w  w  w  ',
      ' cacccacccaccccwacwcawc ',
      ' accaccaccaccaccaccacca ',
      ' caccaccaccaccaccaccacc ',
      ' cAccAccAccAccAccAccAcc ',
      ' AAAAAAAAAAAAAAAAAAAAAA ',
    ],
  ],
  /* 26 Warehouse — long tiled roof, roof-lantern, shutters, banded cargo doors */
  [
    [
      '                        ',
      '          PPPP          ',
      '          nyyn          ',
      '         nnnnnn         ',
      '    PPPPPPPPPPPPPPPP    ',
      '   PPPPPPPPPPPPPPPPPP   ',
      '  PPpPPpPPpPPpPPpPPpPP  ',
      '  pPPpPPpPPpPPpPPpPPpP  ',
      ' PPpPPpPPpPPpPPpPPpPPpP ',
      ' pPPpPPpPPpPPpPPpPPpPPp ',
      ' pppppppppppppppppppppp ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      '  nqqqqqqqqqqqqqqqqqqn  ',
      '  nqqyyqqqqyyqqqqyyqqn  ',
      '  nqqddqqqqddqqqqddqqn  ',
      '  nqqqqqqqqqqqqqqqqqqn  ',
      '  nnnnnnnnnnnnnnnnnnnn  ',
      '  nqqqqqbbbbbbbbqqqqqn  ',
      '  nqqqqqbbb##bbbqqqqqn  ',
      '  nqqqqqmbb##bbmqqqqqn  ',
      '  nqqqqqbbb##bbbqqqqqn  ',
      '  nnnnnnnnnnnnnnnnnnnn  ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      ' oooooooooooooooooooooo ',
    ],
  ],
];
